import { Yii } from "libraries/interfaces/Yii";
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { HelperService } from 'libraries/hotel/services/helper.service';
import { LanguageService } from 'libraries/service/language/language.service';
import {
    IAccomodation,
    IDescriptionObject,
    IDetailsDescription,
    IRemoteImageDescription,
    IRoomSingleKeyword
} from 'libraries/hotel/models/details';
import { IsNullOrEqualsPipe } from "libraries/pipes/is-null-or-equals/is-null-or-equals.pipe";
import { faQuoteLeft, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { DescriptionHelperService } from "libraries/service/description-helper/description-helper.service";
import { IBookingPropertyDescription } from "libraries/service/resources/booking/interfaces/IGetBookings";
import _cloneDeep from "lodash-es/cloneDeep";

@Component({
    selector: 'description',
    templateUrl: './description.component.html',
    styleUrls: ['./description.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DescriptionComponent implements OnChanges, OnInit {

    @Input()
    public set description(value: IDetailsDescription) {
        if (value && value.hasOwnProperty('descriptions')) {
            this.descriptions = this.helperService.objectToArray(value.descriptions);
        }

        this.descriptionModel = value;
    }

    @ViewChild('keywordsSection')
    public keywordsSection: ElementRef<HTMLElement>;

    public get description(): IDetailsDescription {
        return this.descriptionModel;
    }

    public readonly wordingNoDescription: string = Yii.t("wui-shared-js", "Aucune description disponible");
    public readonly wordingSeeAllKeywords: string = Yii.t('wui-iqbh-js', 'Voir tous les mots-clés');
    public readonly wordingTravellerRating: string = Yii.t('wui-iqbh-js', 'Notation voyageur');
    public readonly wordingStandardRating: string = Yii.t('wui-iqbh-js', 'Notation standard');
    public readonly wordingKeyWords: string = Yii.t('wui-iqbh-js', 'Mots-clés');

    public hasDescription: boolean;
    public descriptions: (IDescriptionObject | IBookingPropertyDescription)[] = [];
    public roomKeywords: IRoomSingleKeyword[];
    public mainVignette: IRemoteImageDescription;
    public mainImage: IRemoteImageDescription;
    public language: string;

    public iconQuoteLeft: IconDefinition = faQuoteLeft;

    private descriptionModel: IDetailsDescription;

    constructor(
        private readonly helperService: HelperService,
        private readonly descriptionHelperService: DescriptionHelperService,
        private readonly languageService: LanguageService,
        private readonly isNullOrEqualsPipe: IsNullOrEqualsPipe,
    ) {
    }

    public ngOnInit(): void {
        this.language = this.languageService.getUserLanguage();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.descriptions = this.descriptionHelperService.replaceHostWithAlias(this.descriptions);

        this.hasDescription = Boolean(
            this.description
            && (
                this.isDescriptionWithKeywords()
                || this.isDescriptionWithAccomodationKeywords()
                || this.description.credit
                || this.isWithDescriptions()
            )
        );

        if (this.hasDescription) {
            this.roomKeywords = (this.description.accomodations || [])
                .flatMap((accomodation: IAccomodation) => accomodation.keywords);
        }

        const mainVignette: IRemoteImageDescription = this.description?.introduction?.medias?.length
            && this.description.introduction.medias[0].vignettes?.length
            && this.description.introduction.medias[0].vignettes[0];
        const mainImage: IRemoteImageDescription = this.description?.introduction?.medias?.length
            && this.description.introduction.medias[0].images?.length
            && this.description.introduction.medias[0].images[0];

        this.mainImage = mainImage;
        if (!mainVignette) {
            if (mainImage) {
                this.mainVignette = {
                    url: mainImage.url,
                    dimension: {
                        width: 100, xUnit: '%',
                    }
                };
            } else if (this.description?.medias?.length && this.description?.medias[0].images?.length) {
                this.mainVignette = {
                    url: this.description.medias[0].images[0].url,
                    dimension: {
                        width: 90,
                        xUnit: 'Px'
                    }
                };
            }
        }else{
            this.mainVignette = mainVignette;
        }

        if(this.mainVignette && !this.mainImage){
            this.mainImage = this.mainVignette;
        }
    }

    public scrollToKeywordsSection(): void {
        this.keywordsSection.nativeElement.scrollIntoView();
    }

    private isDescriptionWithKeywords(): boolean {
        return Boolean(this.description.keyword && this.description.keyword.length);
    }

    private isDescriptionWithAccomodationKeywords(): boolean {
        return Boolean(this.description.accomodations
            && this.description.accomodations.length
            && this.description.accomodations[0].keywords
            && this.description.accomodations[0].keywords.length);
    }

    private isWithDescriptions() {
        return this.descriptions && this.descriptions.length;
    }
}
